import { Fragment, FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PatientApi from "Service/Patient.api";
import { RedoxProblemAltCodeType } from "DataTypes/Services/Patient.type";
import Loader from "Components/Loader";
import NoData from "Components/NoData";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SideModalProps } from "DataTypes/Modal";
import RedoxFormatter from "Utils/Redox.Formatter";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import UpdateProblems from "./UpdateProblems";

export interface DataActionType {
  data: RedoxProblemAltCodeType | null;
  action: "ADD" | "EDIT" | "VIEW" | null;
}

const Problems: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [problemList, setProblemList] = useState<RedoxProblemAltCodeType[]>([]);
  const [loading, setLoading] = useState(true);
  const [dataAction, setDataAction] =
    useState<DataActionType>({ data: null, action: null });

  useEffect(() => {
    handleRedoxCall();
  }, []);

  const handleRedoxCall: () => void = async () => {
    const res = await PatientApi.RedoxProblemSearch({ id1: patientInfo.id });
    if (res?.success) {
      setProblemList(RedoxFormatter.ProblemAltCodeList(res?.data));
    }
    setLoading(false);
  };

  const handleCloseLayer2: () => void = () => {
    setDataAction({ data: null, action: null })
  };

  const Layer1List = (
    problemList.map((el) => {
      return (
        <Typography variant="body2" mb={1} key={el.id}>
          {`• ${el.altCode + " -"} ${el.altCodeName}`}
        </Typography>
      );
    })
  );


  const Layer1 = (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold">Problems</Typography>
        <Box display={"flex"}>
          {/* <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={() => setDataAction({ data: null, action: "ADD" })}
          >
            <ImgPath.PlusIcon titleAccess="Add Medication" />
          </Box> */}
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={() => {
              handleCloseLayer2();
              onClose();
            }}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        {loading ? <Loader /> : problemList.length ? Layer1List : <NoData />}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {dataAction.action && (
        <Box width="64%">
          <UpdateProblems
            dataAction={dataAction}
            onClose={handleCloseLayer2}
            refreshList={handleRedoxCall}
          />
        </Box>
      )}
    </Fragment>
  );
};
export default Problems;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};